import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const cartModel = class {

    async GetCart(type) {
        return await axiosInstance.get(Baseurl +`/cart?cart_type=${type}`);
    }
    async Addcart(data=[]) {
        return await axiosInstance.post(Baseurl +`/cart`,data);
    }
    async Validatecoupun(data=[]) {
        return await axiosInstance.post(Baseurl +`/cart/apply_coupon`,data);
    }
}

export default new cartModel();